import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {WorkrequestUsrViewmodel} from '../workrequest-usr-viewmodel';

@Component({
  selector: 'app-workrequest-usr',
  templateUrl: './workrequest-usr.component.html',
  styleUrls: ['./workrequest-usr.component.css']
})
export class WorkrequestUsrComponent implements OnInit {
  @Input()
  isReadOnly = false;
  @Input()
  workRequestViewModel: WorkrequestUsrViewmodel;
  @Output()
  onViewModelChange: EventEmitter<WorkrequestUsrViewmodel>;

  descriptionOfWorkControl: FormControl;
  descriptionOfWorkControlMaxLength = 400;

  constructor() {
    this.descriptionOfWorkControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.descriptionOfWorkControlMaxLength)
    ])]);
  }

  ngOnInit() {
  }

  get invalid(): boolean {
    this.workRequestViewModel.invalidDivewayError = null;
    if (!this.validateAll()) {
      return false;
    }
  }

  get totalOrderAmount(): number {
    return this.workRequestViewModel.workrequestDetails.totalOrderAmount;
  }

  get isValidSelection(): boolean {
    return this.validateAll();
  }

  get invalidSelectionError(): string {
    return this.workRequestViewModel.invalidSelectionError;
  }

  get errorMessage(): string {
    return this.workRequestViewModel.errorMessage;
  }

  set errorMessage(v: string) {
    this.workRequestViewModel.errorMessage = v;
  }

  set descriptionOfWork(v: string) {
    this.workRequestViewModel.workrequestDetails.descriptionOfWork = v;
  }

  get descriptionOfWork(): string {
    return this.workRequestViewModel.workrequestDetails.descriptionOfWork;
  }

  public validateAll(): boolean {
    this.workRequestViewModel.invalidSelectionError = '';
    if (this.descriptionOfWorkControl.invalid) {
      return false;
    }

    return true;
  }

  displayErrorMessage(): string {

    this.errorMessage = null;

    let errorText = '';

    if (!this.validateAll()) {
      errorText += this.workRequestViewModel.invalidSelectionError + '<br>';
    }
    this.descriptionOfWorkControl.markAsTouched();
    if (this.descriptionOfWorkControl.invalid) {
      if (this.descriptionOfWorkControl.hasError('maxlength')) {
        errorText += 'Description of work cannot exceed' + this.descriptionOfWorkControlMaxLength + 'characters' + '<br>';
      }
      if (this.descriptionOfWorkControl.hasError('required')) {
        errorText += 'Please enter description of work' + '<br>';
      }
    }

    this.markValidationControlsAsUntouched();
    this.errorMessage = errorText.length > 0 ? errorText : null;
    return errorText;
  }

  markValidationControlsAsUntouched() {
    this.descriptionOfWorkControl.markAsUntouched();
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/usr-form/workrequest-usr/workrequest-usr.component.ts